import { render, staticRenderFns } from "./PacieAmbu.vue?vue&type=template&id=f2b1d974&"
import script from "./PacieAmbu.vue?vue&type=script&lang=js&"
export * from "./PacieAmbu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports